import { styled } from "@vitality-ds/system";
import baseBadgeStyles from "./styles/BaseBadge.styles";

// eslint-disable-next-line import/prefer-default-export
export var BaseBadge = styled("div", baseBadgeStyles);